import { type ReactionsSummaryQueryResponse } from '@post-office/growth-common';

export type ReactionSummary = {
	ari: string;
	containerAri: string;
	emojiId: string;
	count: number;
	reacted: boolean;
};

export const reactionsMapper = (reactionsList?: ReactionsSummaryQueryResponse) => {
	return reactionsList?.reactionsSummary?.reactionsSummaryForEmoji
		.map((emojiSummary) => {
			if (!emojiSummary) {
				return null;
			}
			return {
				ari: reactionsList.reactionsSummary?.ari ?? '',
				containerAri: reactionsList.reactionsSummary?.containerAri ?? '',
				emojiId: emojiSummary.emojiId,
				count: emojiSummary.count,
				reacted: emojiSummary.reacted,
			};
		})
		.filter(Boolean) as ReactionSummary[];
};
